export const RADIUS_NONE = '0';
export const RADIUS_SSM = '4px';
export const RADIUS_SM = '8px';
export const RADIUS_MD = '16px';
export const RADIUS_LG = '24px';
export const RADIUS_XL = '32px';
export const RADIUS_PILL = '9999px';
export const RADIUS_CIRCLE = '50%';

export const RADIUS = {
  NONE: RADIUS_NONE,
  SSM: RADIUS_SSM,
  SM: RADIUS_SM,
  MD: RADIUS_MD,
  LG: RADIUS_LG,
  XL: RADIUS_XL,
  PILL: RADIUS_PILL,
  CIRCLE: RADIUS_CIRCLE,
};
